import createTransport from 'spotify-transport';
import { Event } from 'spotify-transport/types';
import { accessTokenManager } from '@mrkt/features/webgate-fetch';

export const transport = createTransport({
  providers: {
    endpoints: () => {
      return Promise.resolve({
        // default uses sp-client and we only allow generic.wg in our CSP headers
        webgate: 'https://generic.wg.spotify.com/',
      });
    },
    token: () => accessTokenManager.get(),
  },
});

transport.on(Event.TRANSPORT_CONNECTED, () => {
  transport.authenticate();
});

// failing in tests for some reason, need to fix
if (process.env.NODE_ENV !== 'test') {
  transport.connect();
}
